import { useState } from 'react';
import { X, Mail } from 'lucide-react';

// Mottaker for kontakt/feedback. Endre her hvis e-posten byttes.
const CONTACT_EMAIL = 'tmfoght@gmail.com';

// Kontaktskjema som åpner brukerens egen e-postklient (mailto).
// Meldingen havner rett i innboksen til CONTACT_EMAIL — ingenting lagres
// av oss. Brukes både på forsiden (utlogget) og inne i appen.
export default function ContactModal({ onClose }) {
  const [contactForm, setContactForm] = useState({ email: '', message: '' });
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!contactForm.message.trim()) {
      setError('Vennligst skriv en melding');
      return;
    }
    setError('');

    const subject = 'Tilbakemelding til FiskDa';
    const bodyLines = [
      contactForm.message.trim(),
      '',
      '—',
      contactForm.email.trim()
        ? `Svar til: ${contactForm.email.trim()}`
        : 'Avsender oppga ingen e-post.',
    ];
    const mailto =
      `mailto:${CONTACT_EMAIL}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(bodyLines.join('\n'))}`;

    // Åpne brukerens e-postklient
    window.location.href = mailto;

    // Vis bekreftelse (klienten åpnes i et eget vindu/app)
    setSent(true);
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[200] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-[#F8F5F0] border-2 border-[#3B4D3C] rounded-lg shadow-2xl max-w-md w-full p-8 relative animate-in fade-in duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#3B4D3C]/60 hover:text-[#3B4D3C] transition-colors"
          aria-label="Lukk"
        >
          <X size={24} />
        </button>

        <h3 className="text-2xl font-black italic text-[#3B4D3C] mb-2">
          Kontakt oss
        </h3>
        <p className="font-sans text-sm text-[#2D3436]/70 mb-6">
          Send oss feedback eller spørsmål. Knappen åpner e-postappen din med
          meldingen klar til å sendes.
        </p>

        {sent ? (
          <div className="text-center py-8 space-y-4">
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
              E-postappen din skal nå ha åpnet seg med meldingen. Trykk send
              der, så har vi den.
            </div>
            <p className="font-sans text-xs text-[#2D3436]/60">
              Skjedde ingenting? Send til{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#E67E22] font-semibold hover:underline">
                {CONTACT_EMAIL}
              </a>
            </p>
            <button
              onClick={onClose}
              className="w-full px-6 py-3 bg-[#3B4D3C] text-[#F8F5F0] rounded shadow-md font-sans font-semibold hover:bg-[#2D3A2D] transition-all duration-300"
            >
              Lukk
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block font-sans text-sm font-semibold text-[#3B4D3C] mb-2">
                Din e-post (valgfritt)
              </label>
              <input
                type="email"
                value={contactForm.email}
                onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                placeholder="din@epost.no"
                className="w-full px-4 py-2 border border-[#D1CCC0] rounded font-sans text-sm focus:outline-none focus:border-[#3B4D3C] transition-colors"
              />
              <p className="font-sans text-xs text-[#2D3436]/50 mt-1">
                Så vi vet hvem vi skal svare.
              </p>
            </div>

            <div>
              <label className="block font-sans text-sm font-semibold text-[#3B4D3C] mb-2">
                Melding *
              </label>
              <textarea
                value={contactForm.message}
                onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                placeholder="Skriv din melding her..."
                rows={5}
                required
                className="w-full px-4 py-2 border border-[#D1CCC0] rounded font-sans text-sm focus:outline-none focus:border-[#3B4D3C] transition-colors resize-none"
              />
            </div>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full px-6 py-3 bg-[#3B4D3C] text-[#F8F5F0] rounded shadow-md font-sans font-semibold hover:bg-[#2D3A2D] transition-all duration-300 flex items-center justify-center gap-2"
            >
              <Mail size={18} />
              Åpne e-post
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
